import React from "react";
import { Text, H1, Box, Button, H2 } from "components/ui";
import Breadcrumbs from "components/general/Breadcrumbs";
import { useIsMobile } from "utils/hooks/useIsMobile";
import { ChevronDown } from "lucide-react-native";
import { useToken } from "@gluestack-style/react";

type Props = {
	isMainScreen?: boolean;
};

const ServiceOrderHeader = ({ isMainScreen = true }: Props) => {
	const isMobile = useIsMobile();
	const resolvedPrimarylight = useToken("colors", "primarylight");

	return (
		<>
			{isMainScreen && (
				<Box paddingHorizontal={isMobile ? 12 : 0} paddingVertical={20}>
					<Breadcrumbs />
				</Box>
			)}

			<Box flexDirection="row" paddingHorizontal={isMobile ? 12 : 0}>
				{isMainScreen && <H1>Service History</H1>}
				{!isMainScreen && <H2>Service History</H2>}
			</Box>
			{isMobile && (
				<Box paddingHorizontal={12}>
					<Button variant="outline">
						<Text color="$primarylight" fontWeight={"bold"}>
							Show Filters
						</Text>
						<ChevronDown color="#2B6FBB" />
					</Button>
				</Box>
			)}
		</>
	);
};

export default ServiceOrderHeader;
